import {
    Interview,
    InterviewLanguage,
    MultipleChoiceQuestionDetail,
    Question,
    QuestionType,
} from '@synergetx/puppet-interview-types';
import { InterviewEdited } from '../types';
import omit from 'lodash/omit';

const DEFAULT_CHOICES = { choices: ['', '', ''], content: '' };

export const prepareInterviewToSavetoDB = (interview: InterviewEdited): Interview => {
    interview.questions.forEach((q, i) => {
        // set question position, can get outdated when question order gets changed
        q.position = i;
    });

    return interview;
};

export const removeKeysAfterQuestionTypeChange = (
    question: Question,
    languages: InterviewLanguage[], // FIXME: delete this
    type: QuestionType,
) => {
    let questionToReturn = { ...question, type };
    if (questionToReturn.type !== QuestionType.PUPPET) {
        const puppetKeysToRemove = ['askWhichOne', 'afterSelection'].concat('localeContent');
        questionToReturn = {
            ...omit(questionToReturn, puppetKeysToRemove),
        } as Question;
    }
    if (questionToReturn.type === QuestionType.MULTIPLE) {
        const localeContent = languages.reduce(
            (questionLanguageDetails: MultipleChoiceQuestionDetail['localeContent'], language) => {
                const questionInLanguage = questionToReturn?.localeContent?.[language];
                return {
                    ...questionLanguageDetails,
                    [language]:
                        questionInLanguage &&
                        'choices' in questionInLanguage &&
                        questionInLanguage['choices']
                            ? {
                                  ...questionInLanguage,
                                  choices: questionInLanguage.choices,
                              }
                            : DEFAULT_CHOICES,
                };
            },
            {},
        );

        questionToReturn = {
            selectMultiple: false, // default to single choice
            ...questionToReturn,
            localeContent,
        } as Question;
    } else {
        questionToReturn = {
            ...omit(questionToReturn, 'localeContent'),
        } as Question;
    }
    return questionToReturn as Question;
};
